module.exports = __webpack_public_path__ + "static/media/arrow-down.7882eb89.svg";